module.exports = __webpack_public_path__ + "static/media/unstake.13df8ee3.svg";